import { buildModelManager } from "../builder.js";
const DefaultClinicalSiteSelection = {
  __typename: true,
  id: true,
  accessInstructions: { markdown: true, truncatedHTML: true },
  address: true,
  affiliatedInstitutions: true,
  affiliatedPreceptors: true,
  agencyId: true,
  autoCreatedFromSync: true,
  createdAt: true,
  createdById: true,
  emergencyContact: true,
  geocodedAt: true,
  geocodingError: true,
  geocodingStatus: true,
  geofencePolygon: true,
  geofenceRadius: true,
  geofenceType: true,
  institutionSpecificRequirements: true,
  institutionSpecificUnits: true,
  institutionalGeofences: true,
  isActive: true,
  isSharedResource: true,
  lastModifiedById: true,
  lastSyncedAt: true,
  latitude: true,
  longitude: true,
  name: true,
  needsGeofenceSetup: true,
  notes: { markdown: true, truncatedHTML: true },
  operatingHours: true,
  originalInstitution: true,
  originalSiteId: true,
  primaryGeofence: true,
  sharePermissions: true,
  sharedWithInstitutions: true,
  siteContactPerson: true,
  siteEmail: true,
  sitePhone: true,
  specialRequirements: { markdown: true, truncatedHTML: true },
  units: true,
  updatedAt: true
};
const modelApiIdentifier = "clinicalSite";
const pluralModelApiIdentifier = "clinicalSites";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultClinicalSiteSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultClinicalSiteSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultClinicalSiteSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultClinicalSiteSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultClinicalSiteSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultClinicalSiteSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultClinicalSiteSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createClinicalSite",
    operationReturnType: "CreateClinicalSite",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      clinicalSite: { required: false, type: "CreateClinicalSiteInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultClinicalSiteSelection
  },
  {
    type: "action",
    operationName: "bulkCreateClinicalSites",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateClinicalSitesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultClinicalSiteSelection
  },
  {
    type: "action",
    operationName: "updateClinicalSite",
    operationReturnType: "UpdateClinicalSite",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      clinicalSite: { required: false, type: "UpdateClinicalSiteInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultClinicalSiteSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateClinicalSites",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateClinicalSitesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultClinicalSiteSelection
  },
  {
    type: "action",
    operationName: "deleteClinicalSite",
    operationReturnType: "DeleteClinicalSite",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteClinicalSites",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertClinicalSite",
    operationReturnType: "UpsertClinicalSite",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      clinicalSite: { required: false, type: "UpsertClinicalSiteInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateClinicalSiteResult": { hasReturnType: false },
      "... on UpdateClinicalSiteResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultClinicalSiteSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertClinicalSites",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertClinicalSitesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultClinicalSiteSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "clinicalSiteGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ClinicalSiteManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultClinicalSiteSelection,
  operations
);
export {
  ClinicalSiteManager,
  DefaultClinicalSiteSelection
};
//# sourceMappingURL=ClinicalSite.js.map
